import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '@app/core/services/order.service';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { AppState, selectProfile } from '@app/core/ngrx';
/**
 * OrderComponent
 */
@Component({
  selector: 'ecp-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  // @select(['user', 'profile'])
  public user$: Observable<any>;
  public upc;
  /**
   * constructor
   */
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _activeRoute: ActivatedRoute,
    private _orderService: OrderService,
    private store: Store<AppState>,
  ) {
    this.user$ = this.store.pipe(select(selectProfile));
    this.upc = this._activeRoute.snapshot.params.upc;
    this.user$.subscribe((user: any) => {
      window.localStorage.setItem('token', user.token);
    });
  }
  /**
   * ngOnInit
   */
  ngOnInit() {}
}
